import { Node as ReactFlowNode } from '@xyflow/react';
import { CanvasElementType } from '../canvas-types';
import { convertXYPositionToGridIndex } from './gridPositioningUtils';

import { CanvasGridPosition } from './gridPositioningUtils';
import { RfNodeRegularNode, SweepCanvasRfNode } from '../canvas-types/nodeTypesData';

export const findRegularNodeAtGridPosition = ({
  nodes,
  gridPosition,
  compareFn,
}: {
  nodes: SweepCanvasRfNode[];
  gridPosition: CanvasGridPosition;
  compareFn?: (node: ReactFlowNode) => boolean;
}): RfNodeRegularNode | undefined => {
  return nodes.find((node) => {
    if (node.type !== CanvasElementType.REGULAR) {
      return false;
    }
    if (compareFn && !compareFn(node)) {
      return false;
    }

    const { row, column } = convertXYPositionToGridIndex(
      {
        x: node.position.x,
        y: node.position.y,
      },
      { withPaddingByNodeType: node.type },
    );

    const nodePos: CanvasGridPosition = {
      row,
      column,
    };

    return nodePos.column === gridPosition.column && nodePos.row === gridPosition.row;
  }) as RfNodeRegularNode | undefined;
};
